import { useNavigate } from 'react-router-dom'

import Button from '@components/designSystem/Button'
import { Headline } from '@components/designSystem/Headline'
import useTypedTranslation from '@hooks/useTypedTranslation'

function NoAccessRoute() {
  const { t } = useTypedTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center gap-6 px-6 py-20 text-center">
      <Headline title={t('common.accessDenied.title')} />
      <p className='max-w-md text-sm text-secondary'>
        {t('common.accessDenied.description')}
      </p>
      <Button variant='filled' onClick={() => navigate(-1)}>
        {t('common.accessDenied.action')}
      </Button>
    </div>
  )
}

export default NoAccessRoute
